function formatLocalDate(date) {
	var now = date || new Date(),
		tzo = -now.getTimezoneOffset(),
		dif = tzo >= 0 ? '+' : '-',
		pad = function (num) {
			var norm = Math.abs(Math.floor(num));
			return (norm < 10 ? '0' : '') + norm;
		};
	return now.getFullYear()
		+ '-' + pad(now.getMonth() + 1)
		+ '-' + pad(now.getDate())
		+ 'T' + pad(now.getHours())
		+ ':' + pad(now.getMinutes())
		+ ':' + pad(now.getSeconds())
		+ dif + pad(tzo / 60)
		+ ':' + pad(tzo % 60);
}

function isDateInRange(d, start, end) {
	// Checks if date in d is between dates in start and end.
	// Returns a boolean or NaN:
	//    true  : if d is between start and end (inclusive)
	//    false : if d is before start or after end
	//    NaN   : if one or more of the dates is illegal.
	// NOTE: The code inside isFinite does an assignment (=).
	return (
			 isFinite(d.valueOf()) &&
			 isFinite(start.valueOf()) &&
			 isFinite(end.valueOf()) ?
			 start <= d && d <= end :
			 NaN
	 );
}

function getTimeZone() {
    var m = /GMT[\+\-].+$/i.exec((new Date()).toString());
    if (m) {
        return m[0];
    }
}

function isTouchDevice() {
    return 'ontouchstart' in window        // works on most browsers 
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
}